// extracted by mini-css-extract-plugin
module.exports = {"socialProfileForm":"SocialProfileForm__socialProfileForm__yeL05","submitButtonWrapper":"SocialProfileForm__submitButtonWrapper__ohzVZ"};